/**
 * Get channel name from source parameter
 *
 * @param source - Channel source
 */
export const getChannelNameFromSource = (source) => {
    switch (source) {
        case 'Messenger':
            return 'Messenger';
        case 'Msging.net':
        case '0mn.io':
            return 'Blip Chat';
        case 'Take':
        case 'Mailgun':
            return 'Email';
        case 'Telegram':
            return 'Telegram';
        case 'Workplace':
            return 'Workplace';
        case 'WhatsApp':
            return 'WhatsApp';
        case 'Assistant':
            return 'Assistant';
        case 'BusinessChat':
            return 'Apple Messages for Business';
        case 'Instagram':
            return 'Instagram';
        default:
            return source;
    }
};
/**
 * Get user name from user, if not available returns name from user identity
 *
 * @param user - Object representing bot's user
 */
export const getName = (user) => {
    return user.name
        ? tryDecodeURIComponent(user.name)
        : decodeURIComponent(user.identity.slice(0, user.identity.indexOf('@')));
};
const tryDecodeURIComponent = (text) => {
    try {
        return decodeURIComponent(text);
    }
    catch (error) {
        return text;
    }
};
